<template lang="pug">
    v-dialog( fullscreen max-width="80%" v-model="open" )
        v-toolbar( color="grey darken-4" dark sticky flat )
            v-toolbar-title Detalle de Nota de Crédito  
            v-spacer
            v-btn( icon dark @click="toggleOpen")
                v-icon close
        v-card
            v-layout.pa-3( row wrap )
                v-flex( xs12 )
                    crud-form(:fields="fld" noButtons)
                        crud-data-table(
                            :service="service"  
                            :headers="headerTable" 
                            showAll 
                            noActions 
                            slot="appendContent"
                            :filters="[]"
                            noSearchBox
                            )
            
</template>

<script>
import { CrudDataTable, CrudForm } from '@/components/reusable_components'
import { getFetchDataFunction } from '@/services/api/DataTableServiceFromFinanzas'

import headerTable from './headers'
import fieldForm from './fieldForm'
export default {
    name: 'invoice-Detail',
    props: {
        creditNoteId: {
            type: Number,
            required: true,
        },
        /**
         * @description
         */
        readOnly: {
            type: Boolean,
            default: () => false,
        },
        creditNoteModel: {
            type: Function,
            required: true,
        },
    },
    data: function() {
        return {
            open: false,
            service: {
                dtFetchData: () => {},
                dtDeleteItem: () => {},
            },
            headerTable: headerTable,
            fieldsForm: fieldForm,
        }
    },
    computed: {
        /**
         * @description
         */
        fld: function() {
            if (this.readOnly)
                return this.fieldsForm.map(field => {
                    field.type = 'readonly'
                    return field
                })
            return this.fieldsForm
        },
    },
    methods: {
        toggleOpen() {
            this.open = !this.open
        },
        /**
         *
         */
        getInvoiceRecentInformation() {
            const include = ['sl_detail_sale_credit_notes.wh_product']
            const idCreditNote = this.creditNoteId
            const url = process.env.VUE_APP_API_ROUTE.concat(
                `/sl_sale_credit_note/${idCreditNote}`
            )

            this.service.dtFetchData = getFetchDataFunction(
                url,
                include,
                [],
                response => {
                  console.log(response.data,'data  response getInvoiceRecentInformation')
                    console.log(response.data.sl_detail_sale_credit_notes,'response getInvoiceRecentInformation')
                    let newResponse = {}
                    newResponse.data = [
                        ...response.data.sl_detail_sale_credit_notes,
                    ]
                    return newResponse
                }
            )
        },
        /**
         *
         */
        async getGeneralInfoCreditNote() {
            const include = ['sl_detail_sale_credit_notes.wh_product']
            let response = await this.creditNoteModel
                .append('reference_dte')
                .include(include)
                .find(this.creditNoteId)
            console.log(response, 'response')
            this.fillForm(response)
        },
        /**
         *
         */
        fillForm(data) {
            console.log(data, 'data fillform')
            let fields = [...this.fieldsForm]
            fields[0].value = this.typeSiiDocument(data.dte_type_credit_note)
            fields[1].value = data.number
            fields[2].value = this.typeSiiDocument(this.referenceDocument(data))
            fields[3].value = data.reference_dte.number
            fields[4].value = data.net_total
            fields[5].value = data.iva
            fields[6].value = data.total
            fields[7].value = data.global_discount_percentage
            fields[8].value = data.global_discount_amount
            this.fieldsForm = [...fields]
        },
        /**
         *
         */
        typeSiiDocument(code) {
            const SII_DOCUMENTS = [
                {
                    code: 33,
                    name: 'Factura Electrónica',
                },
                {
                    code: 39,
                    name: 'Boleta Electrónica',
                },
                {
                    code: 61,
                    name: 'Nota de crédito',
                },
            ]
            let foundDocument = SII_DOCUMENTS.filter(item => {
                if (item.code === code) {
                    return item
                }
            })
            return foundDocument.length>0
                ? foundDocument[0].name
                : `código ${code} no encontrado`
        },
        referenceDocument(data){
          if(data.reference_dte.dte_type_invoice){
            return 33 //factura
          }
          else{
            return 39 //boleta
          }

        }
    },
    watch: {
        open(val) {
            if (val == true) {
                this.getInvoiceRecentInformation()
                this.getGeneralInfoCreditNote()
            }
        },
    },
    components: {
        CrudDataTable,
        CrudForm,
    },
    mixins: [],
    filters: {},
    // Lifecycle Methods
    //
    // beforeCreate: function(){...},
    // created: function(){...},
    // beforeMount: function(){
    //     this.getInvoiceRecentInformation()
    // },
    // mounted: function(){
    //     this.getInvoiceRecentInformation()
    // },
    // beforeUpdate: function(){...},
    updated: function() {
        //this.getInvoiceRecentInformation()
    },
    // beforeDestroy: function(){...},
    // destroyed: function(){...},
    //
    // End Lifecycle Methods
}
</script>

<style lang="scss"></style>
